import { render, staticRenderFns } from "./SuijinDetail.vue?vue&type=template&id=ed10170e&scoped=true&"
import script from "./SuijinDetail.vue?vue&type=script&lang=js&"
export * from "./SuijinDetail.vue?vue&type=script&lang=js&"
import style0 from "./SuijinDetail.vue?vue&type=style&index=0&id=ed10170e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed10170e",
  null
  
)

export default component.exports